import React from 'react';
import { Box, List, Typography } from '@mui/material';
import { PanelFrame } from './SharedFrames';
import EventFeedItem from './EventFeedItem';

const StrategyEventFeedPanel = ({
    strategyLabel,
    eventFeedRows = [],
    feedHeight = 380,
    minHeight,
    framed = true,
}) => {
    const content = eventFeedRows.length ? (
        <Box
            sx={{
                maxHeight: feedHeight,
                overflowY: 'auto',
                pr: 0.5,
            }}
        >
            <List disablePadding>
                {eventFeedRows.map((event, index) => (
                    <EventFeedItem
                        key={`${event.occurredAt || index}-${event.message}`}
                        event={event}
                        divider={index < eventFeedRows.length - 1}
                    />
                ))}
            </List>
        </Box>
    ) : (
        <Typography variant="body2" color="text.secondary">
            No strategy events have arrived yet.
        </Typography>
    );

    if (!framed) {
        return <Box>{content}</Box>;
    }

    return (
        <PanelFrame
            accent="strategy"
            eyebrow="Event Flow"
            title="Strategy Event Feed"
            description={`Most recent decisioning, execution, and session commentary emitted by ${strategyLabel}.`}
            minHeight={minHeight}
        >
            {content}
        </PanelFrame>
    );
};

export default StrategyEventFeedPanel;
